import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';

import { CommonState } from './reducer';
import { getDisableControl } from 'utils/search';

export const getCommonState = (state: RootState) => state.common;

export const getIsPackagePrice = createSelector(getCommonState, (state: CommonState) => {
  return typeof state.isPackagePrice !== 'object' && state.isPackagePrice;
});

export const getUserIdentifier = createSelector(getCommonState, (state: CommonState) =>
  state.userIdentifier ? state.userIdentifier : undefined,
);

export const getIsDisabledComponent = createSelector(getCommonState, (state: CommonState) => {
  const isDisabled = getDisableControl(state.isDisabledComponent);
  return isDisabled;
});
